import { useEffect, useState } from "react";

/** Tracks window.visualViewport so fixed overlays hug the ACTUAL visible area
 *  on iOS — Safari's `fixed bottom-0` hides content under the bottom toolbar,
 *  and the on-screen keyboard covers it. Returns null where unsupported. */
export function useVisualViewport() {
  const [vv, setVv] = useState(null);
  useEffect(() => {
    const v = window.visualViewport;
    if (!v) return undefined;
    const apply = () => setVv({ height: v.height, offsetTop: v.offsetTop, width: v.width, offsetLeft: v.offsetLeft });
    apply();
    v.addEventListener("resize", apply);
    v.addEventListener("scroll", apply);
    return () => {
      v.removeEventListener("resize", apply);
      v.removeEventListener("scroll", apply);
    };
  }, []);
  return vv;
}

/** iOS keeps whatever pinch/focus zoom the page ended up with. Toggling
 *  maximum-scale on the viewport meta for a tick forces it back to 1:1 —
 *  the only way to un-zoom programmatically. No-op when not zoomed. */
export function resetPageZoom() {
  const v = window.visualViewport;
  if (!v || v.scale <= 1.01) return;
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  const original = meta.getAttribute("content") || "";
  meta.setAttribute("content", `${original}, maximum-scale=1`);
  setTimeout(() => meta.setAttribute("content", original), 300);
}
